/**
 * Trello API configuration
 * TODO: Move these to environment variables for production
 */

export const TRELLO_CONFIG = {
  API_KEY: '6771f94f07fd78cfa672561f4c2537a9',
  BASE_URL: 'https://api.trello.com/1',
  BOARD_ID: '5ac2799ad3fa3841eb051441',
  LIST_ID: '68823724afefc05e774518db',
  
  // OAuth URLs
  AUTH_URL: 'https://trello.com/1/authorize',
  
  // Scopes and permissions
  SCOPE: 'read,write',
  EXPIRATION: 'never',
  NAME: 'Lead Gen UI Integration'
};

// Helper function to get the correct return URL based on environment
export const getTrelloReturnUrl = (): string => {
  // In production, always use the production URL
  if (window.location.hostname === 'leads.modul.ai') {
    return 'https://leads.modul.ai';
  }
  
  // For development, use localhost
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:3000';
  }
  
  // Fallback to current origin
  return window.location.origin;
};

// Helper function to generate Trello auth URL
export const getTrelloAuthUrl = (returnUrl?: string): string => {
  const params = new URLSearchParams({
    key: TRELLO_CONFIG.API_KEY,
    name: TRELLO_CONFIG.NAME,
    scope: TRELLO_CONFIG.SCOPE,
    expiration: TRELLO_CONFIG.EXPIRATION,
    response_type: 'token',
    callback_method: 'postMessage',
    return_url: returnUrl || getTrelloReturnUrl()
  });
  
  return `${TRELLO_CONFIG.AUTH_URL}?${params.toString()}`;
};